"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertPrecision = exports.positiveOrZero = exports.bnOrZero = exports.bn = void 0;
const bignumber_js_1 = __importDefault(require("bignumber.js"));
__exportStar(require("bignumber.js"), exports);
const bn = (n, base = 10) => new bignumber_js_1.default(n, base);
exports.bn = bn;
const bnOrZero = (n) => {
    const value = (0, exports.bn)(n || 0);
    return value.isFinite() ? value : (0, exports.bn)(0);
};
exports.bnOrZero = bnOrZero;
const positiveOrZero = (n) => {
    const value = (0, exports.bn)(n || 0);
    return value.isPositive() ? value : (0, exports.bn)(0);
};
exports.positiveOrZero = positiveOrZero;
const convertPrecision = ({ value, inputExponent = 0, outputExponent = 0, }) => {
    return (0, exports.bnOrZero)(value)
        .dividedBy((0, exports.bn)(10).exponentiatedBy(inputExponent))
        .multipliedBy((0, exports.bn)(10).exponentiatedBy(outputExponent));
};
exports.convertPrecision = convertPrecision;
